import React from 'react';
import { LockIcon } from 'lucide-react';
export function TrustBar() {
  return <div className="w-full border-b border-gold-400/25 bg-forest-950" data-id="element-328" data-mp="1bzvqie21h2kj">
      <p className="mx-auto flex max-w-6xl items-center justify-center gap-2 px-4 py-2 text-center text-[0.65rem] font-bold uppercase tracking-[0.18em] text-gold-400 sm:py-2.5 sm:text-xs sm:tracking-[0.22em]" data-id="element-329" data-mp="1c28jdm9c4xcd">
        <LockIcon className="h-3 w-3 shrink-0 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-330" data-mp="135fwycguok5c" />
        Compra 100% segura
      </p>
    </div>;
}